import { render, staticRenderFns } from "./EntityNew.vue?vue&type=template&id=27420667&scoped=true"
import script from "./EntityNew.vue?vue&type=script&lang=js"
export * from "./EntityNew.vue?vue&type=script&lang=js"
import style0 from "./EntityNew.vue?vue&type=style&index=0&id=27420667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27420667",
  null
  
)

export default component.exports